export default "__VITE_ASSET__d471e259__"